import { Link, useParams } from 'react-router-dom';
import styles from './BackofficeSurveyDetails.module.scss';
import Icon from '../../components/Icon/Icon';
import { FormattedMessage, useIntl } from 'react-intl';
import useBackofficeSurveyDetails from "./useBackofficeSurveyDetails";
import Spinner from "../../components/Spinner/Spinner";
import {Button, Input} from "antd";
import {Respondent} from "./BackofficeSurveyDetails.model";
import {useHistory} from "react-router-dom";
import moment from "moment";

const BackofficeFeedbackDetails = () => {
	const { id } = useParams<{ id: string }>();
	const intl = useIntl();
	const { state, editSurvey, setSurveyResponseLink } = useBackofficeSurveyDetails({ id });

	const { survey, surveyResponseLink } = state;
	const history = useHistory();

	const renderUserInfo = (user: Respondent, key: number) => {
		return (
			<div className={styles.user} key={key} onClick={!user.isDeleted ? () => history.push(`/users/${user.userId}`) : undefined}>
				<div className={styles.iconContainer}>
					{user?.imageId ? (
						<img alt="" src={user?.imageId} className={styles.avatar} />
					) : (
						<div className={styles.avatar}>
							<Icon color="text" height="12px" name="user" width="12px" />
						</div>
					)}
				</div>
				<div className={styles.info}>
					<div>
						{user?.firstName} {user?.lastName}
					</div>
				</div>
			</div>
		);
	};

	const renderTabs = () => {
		return (
			<div className={styles.actions}>
				<div className={styles.breadcrumbs}>
					<Link
						to={{
							pathname:  '/surveys'
						}}
					>
						<FormattedMessage id="navigation.survey"/> /
					</Link>
					<span>{"Quality of mentoring relationship"}</span>
				</div>
			</div>
		);
	};
	
	return (
		<div className={styles.pageContainer}>
			<div className={styles.pageContent}>
				<div>{renderTabs()}</div>
				<div style={{ padding: '24px' }}>
					<div style={{ marginTop: '15px' }}>
						<span className={styles.textColor}>
							<FormattedMessage id="surveyDetails.surveyDate" />
						</span>{' '}
						<span className={styles.applicationDate}>
							{survey?.date &&
							moment(survey.date).format("DD MMM YYYY")}{' '}
						</span>
					</div>
					<div className={styles.content}>
						<Spinner spinning={false} />
						<div className={styles.category}>
							<div className={styles.categoryTitle}>
								<Icon
									name="file-alt"
									type="solid"
									color="light"
									width="16px"
									height="16px"
								/>
								<h2>
									<FormattedMessage id="surveyDetails.links" />
								</h2>
							</div>
							<div className={styles.categoryContent}>
								<div className={`${styles.fieldWrapper} ${styles.surveyLink}`}>
									<a href={survey?.surveyLink} target="_blank" rel="noreferrer">{survey?.surveyLink}</a>
								</div>
								<div className={styles.fieldWrapper} style={{width: '60%'}}>
									<label className={styles.floatingLabel}>
										<FormattedMessage id="formLabels.surveyResultLink" />
									</label>
									<div className={styles.changeLinkContainer}>
									<Input
										// className={errors['title'] && 'error'}
										placeholder={intl.formatMessage({
											id: `formPlaceholders.surveyResultLink`,
										})}
										value={surveyResponseLink}
										defaultValue={surveyResponseLink} onChange={(event) => {
											setSurveyResponseLink( event.target.value);
									}}
									/>
									<Button type="link" onClick={editSurvey}><FormattedMessage id="buttons.save" /></Button>
									</div>
								</div>
							</div>
							
						</div>
						<div className={styles.category}>
							<div className={styles.categoryTitle}>
								<Icon
									name="comment-alt"
									type="solid"
									color="light"
									width="16px"
									height="16px"
								/>
								<h2>
									<FormattedMessage id="surveyDetails.respondents" />
								</h2>
							</div>
							<div className={styles.categoryContent}>
								<h2>
									<FormattedMessage id="surveyDetails.name" />
								</h2>
								{survey?.respondents.map((item, key) => {
									return renderUserInfo(item, key);
								})}
							</div>
						</div>
					</div>
					
				</div>
			</div>
		</div>
	);
};
export default BackofficeFeedbackDetails;
